import { IPoint } from "./IPoint";

export interface ISafegraphLocation {
  locationId: string;
  brandId: string;
  brandName: string;
  naicsCode: string;
  categoryName: string;
  subCategoryName: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  dmaId: number;
  regionCd: string;
  latitude: number;
  longitude: number;
  placeKey: string;
  sgVintage: Date;
  polygon: IPoint[];
  distanceMiles: number;
}

export interface ISafegraphMapData {
  uniqueID: string;
  brandId: string;
  name: string;
  latitude: number;
  longitude: number;
  spatialObject: IPoint[];
  address: {
    address1: string;
    country: string;
    state: string;
    city: string;
    zip: string;
    zip4: string;
  };
  type: string;
}

export interface ISafegraphBrandMapValue {
  ID: string;
  type: string;
  mapData: ISafegraphMapData[];
  logoPath: string;
  name: string;
}
